import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req} from '@nestjs/common';
import {  InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError,  errorHandler, ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { CertificatesResponseModel, AllCertificatesResponseModel} from '@gtpl/shared-models/masters';
import { CertificatesService } from './certificates.service';
import { CertificatesRequest } from './dto/certificates.request';
import { CertificatesDTO } from './dto/certificates.dto';
import { UserRequestDto } from './dto/user-request-dto';

@ApiTags('certificates')
@Controller('certificates')
export class CertificatesController {
    constructor(
        private certificatesService: CertificatesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
    @Post('/createCertificate')
    async createCertificate(@Body() certificatesDto:CertificatesDTO,isUpdate:boolean=false): Promise<CertificatesResponseModel> {
    try {
        return await this.certificatesService.createCertificate(certificatesDto, false);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CertificatesResponseModel, error);
      }
    }
    @Post('/updateCertificates')
  async updateCertificates(@Body() certificatesDto: CertificatesDTO,@Req() request:UserRequestDto): Promise<CertificatesResponseModel> {
    try {
      // console.log('update Certificates');
      // console.log(request);
      return await this.certificatesService.createCertificate(certificatesDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CertificatesResponseModel, error);
    }
  }
  @Post('/getAllCertificates')
  // @UseGuards(AuthGuard('jwt'))
  async getAllCertificates(@Body() req?:UserRequestDto): Promise<AllCertificatesResponseModel> {
    try {
      return await this.certificatesService.getAllCertificates(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllCertificatesResponseModel, error);
    }
  }
  @Post('/activateOrDeactivateCertificates')
  async activateOrDeactivateCertificates(@Body() certificatesRequest: CertificatesRequest): Promise<CertificatesResponseModel> {
      try {
          return await this.certificatesService.activateOrDeactivateCertificates(certificatesRequest);
      } catch (err) {
          return this.applicationExceptionHandler.returnException(CertificatesResponseModel, err);
      }
  }
  @Post('/getAllActiveCertificates')
  async getAllActiveCertificates(@Req() request: Request): Promise<AllCertificatesResponseModel> {
      try {
          return await this.certificatesService.getAllActiveCertificates();
      } catch (error) {
          return this.applicationExceptionHandler.returnException(AllCertificatesResponseModel, error)
      }
  }
  @Post('/getCertificationById')
  async getCertificationById(@Body() certificatesRequest:CertificatesRequest,@Req() request: Request): Promise<CertificatesResponseModel> {
      try {
      return await this.certificatesService.getCertificationById(certificatesRequest);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CertificatesResponseModel, error)
      }
  }
}
